import { SVGProps } from 'react';

export const CheckboxIndeterminate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <rect width="22" height="22" rx="4" fill="white" />
    <path
      d="M5.19862 12.4063H16.8014V9.59375H5.19862V12.4063ZM3.07473 22C2.21806 22 1.49144 21.7017 0.894863 21.1051C0.298288 20.5086 0 19.7819 0 18.9253V3.07473C0 2.21806 0.298288 1.49144 0.894863 0.894863C1.49144 0.298287 2.21806 0 3.07473 0H18.9253C19.7819 0 20.5086 0.298287 21.1051 0.894863C21.7017 1.49144 22 2.21806 22 3.07473V18.9253C22 19.7819 21.7017 20.5086 21.1051 21.1051C20.5086 21.7017 19.7819 22 18.9253 22H3.07473Z"
      fill="currentColor"
    />
  </svg>
);
